// EXPORT EXCEL
const BORDER = {
  top: { style: "thin", color: { auto: 1 } },
  right: { style: "thin", color: { auto: 1 } },
  left: { style: "thin", color: { auto: 1 } },
  bottom: { style: "thin", color: { auto: 1 } },
};

const BG_HEADER = {
  font: {
    bold: true,
  },

  alignment: {
    vertical: "center",
    horizontal: "center",
  },
};

function getColumnNameInExcel(sheets) {
  // FIND NAME COLUMNS TO ADD BORDER
  const columnNames = [];
  for (let i in sheets) {
    if (
      columnNames.indexOf(i.replace(/[0-9]/g, "")) === -1 &&
      i.indexOf("!") === -1
    ) {
      columnNames.push(i.replace(/[0-9]/g, ""));
    }
  }
  return columnNames;
}

function checkSheetTypeForTableAttendanceSheet(sheet = {}) {
  let object = {
    t: "s",
    v: "",
    s: { border: { ...BORDER } },
  };
  if (!sheet.z) {
    if (sheet.v !== "" && +sheet.v >= 0) {
      object = {
        ...sheet,
        t: "n",
        v: +sheet.v || 0,
        s: { ...sheet.s, border: { ...BORDER } },
      };
    } else if (sheet.v && typeof sheet.v === "string") {
      object = {
        ...sheet,
        v: sheet.v,
        t: "s",
        s: { ...sheet.s, border: { ...BORDER } },
      };
    } else if (!sheet.v) {
      object = {
        ...sheet,
        t: "s",
        v: "",
        s: { ...sheet.s, border: { ...BORDER } },
      };
    }
  }

  // if is date format
  if (sheet.z === "m/d/yy") {
    object = {
      ...sheet,
      t: "d",
      v: sheet.v,
      s: { ...sheet.s, border: { ...BORDER } },
    };
  }

  return { ...object };
}

function setSheetIsString({ sheets, rowStart, rowEnd }) {
  const CELL = ["D"];
  for (let i in CELL) {
    const name = CELL[i];
    let j = rowStart;
    while (j <= rowEnd) {
      sheets[name + j] = {
        ...sheets[name + j],
        v: sheets[name + j].v + "",
        t: "s",
      };

      j += 1;
    }
  }
  return sheets;
}

function addBorderTableAttendanceSheet(columnNames, sheets, rowStart, rowEnd) {
  for (let i in columnNames) {
    const name = columnNames[i];
    let j = rowStart;
    while (j <= rowEnd) {
      sheets[name + j] = checkSheetTypeForTableAttendanceSheet(
        sheets[name + j]
      );

      j += 1;
    }
  }
  return sheets;
}

function findRowEnd(sheets) {
  const REF = sheets["!ref"];
  const SPLIT_REF = REF.split(":");
  const GET_END_ROW = SPLIT_REF && SPLIT_REF[1];
  return +GET_END_ROW.match(/\d+/)[0] || null;
}

export function formatCell(sheets) {
  // hang dau tien la header
  for (let i in sheets) {
    if (sheets[i.replace(/[0-9]/g, "") + 1]) {
      sheets[i.replace(/[0-9]/g, "") + 1] = {
        ...sheets[i.replace(/[0-9]/g, "") + 1],
        s: { ...BG_HEADER },
      };
    }
  }

  const columnNames = getColumnNameInExcel(sheets);
  const ROW_END = findRowEnd(sheets); // SUBTRACT 2 BECAUSE EMPTY SPACE
  const ROW_START = 1; // ALLWAY START IS ROW 1 IN EXCEL

  sheets = addBorderTableAttendanceSheet(
    columnNames,
    sheets,
    ROW_START,
    ROW_END
  );
}
